export const H5 = function (fn) {

    fn();

};
export const APP = function (fn) {



};
export const applets = function (fn) {



};
export const notH5 = function (fn) {



};
export const baiduApple = function (fn) {



};
export const touTiao = function (fn) {



};
export const mp = function (fn) {



};
